module.exports = __webpack_public_path__ + "static/media/maintitle01.7603ccdd.svg";